export const backgroundColor = {
  'to do': ' rgb(142, 146, 204)',
  'in progress': 'lightgreen',
  done: 'rgb(40, 44, 52)',
  complete: 'rgb(40, 44, 52)',
  blocked: 'red',
  'low priority': 'rgb(207, 206, 163)',
  'medium priority': 'rgb(221, 201, 149)',
  'normal priority': 'rgb(221, 201, 149)',
  'high priority': 'rgb(231, 182, 116)',
  'critical': 'rgb(228, 146, 141)',
  'very high priority': 'rgb(228, 146, 141)',
};
